// extracted by mini-css-extract-plugin
export default {"wrapper":"eo","centered":"fo","gridWrapper":"go","grid":"ho","oneColumn":"io","marginLeftAuto":"jo"};